<template>
  <div class="page-4-container">
    <div class="header-wrapper">
      <img :src="image" width="160px" />
    </div>
    <div class="mt-4 mb-5">
      <div class="title">
        {{ title }}
      </div>
      <div class="subtitle">
        {{ subtitle }}
      </div>
    </div>
    <div class="footer-wrapper">
      <McButton
        text="Mengerti"
        block
        @click="handleHide"
      />
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton
  },
  props: {
    isSuccess: {
      type: Boolean,
      required: true
    },
  },
  emits: ['change-page'],
  computed: {
    image() {
      return require(`@/assets/images/message/${this.isSuccess ? 'success' : 'failed'}-message.svg`)
    },
    title() {
      return this.isSuccess ? 'Permintaan Anda Telah Terkirim' : 'Permintaan Gagal Terkirim'
    },
    subtitle() {
      return this.isSuccess ? 'Kami akan memberitahu Anda jika kendaraan sudah mendekati lokasi tujuan via WhatsApp' : 'Ada kendala ketika mengirim permintaan Anda. Silahkan coba beberapa saat lagi'
    }
  },
  mounted() {
    if (this.isSuccess) {
      this.$store.dispatch('trackingTemp/resetAllState')
    } else {
      this.$store.dispatch('trackingTemp/resetLoadingState')
    }
  },
  methods: {
    handleHide() {
      if (this.isSuccess) {
        this.$bvModal.hide('notification-wa-modal')
      } else {
        this.$emit('change-page', 1)
      }
    }
  }
}
</script>
